// Official brandbook colors (Digital/Numérique)
export const COLORS = {
  azur: [57, 125, 255],
  anthracite: [25, 29, 30],
  blancLunaire: [245, 246, 249],
  argent: [191, 198, 204],
  grisAcier: [147, 155, 160],
  bleuPetroleLight: [104, 113, 117],
  bleuPetroleDark: [60, 70, 73],
  ambre: [249, 200, 14],
  ambreLight: [254, 247, 205],
  emeraude: [16, 209, 131],
  emeraudeLight: [220, 252, 231],
  vertJaune: [170, 254, 0],
  white: [255, 255, 255],
  pageNumberGray: [230, 235, 242],
};

export const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const LOGO_URL = '/logo-pde-noir.png';
